import styled from 'styled-components';
import StoreButton from '../StoreButton';

export const Container = styled.div`
  background-color: transparent;
  flex-direction: column;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LogoContainer = styled.div`
  margin-bottom: 10px;
`;

export const Title = styled.text<{theme?: any}>`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 0px;
  color: ${({theme}) => theme.secondary};
`;

export const ButtonsContainer = styled.div`
  flex-direction: row;
  margin-top: 15px;
  margin-bottom: 20px;
`;

export const Button = styled(StoreButton)`
  margin-left: 10px;
  margin-right: 10px;
`;
